/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailPreviewDto
 */
export interface EmailPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    emailType: EmailPreviewDtoEmailTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    htmlContent: string;
}


/**
 * @export
 */
export const EmailPreviewDtoEmailTypeEnum = {
    Orzeczenie: 'Orzeczenie',
    Orzeczenie_angielskie: 'Orzeczenie angielskie',
    Skierowanie: 'Skierowanie',
    Skierowanie_zewntrzne: 'Skierowanie zewnętrzne',
    Skierowanie_Synevo: 'Skierowanie Synevo',
    Potwierdzenie_wizyty: 'Potwierdzenie wizyty',
    Wynik_badania_psychologicznego: 'Wynik badania psychologicznego',
    Potwierdzenie_patnoci: 'Potwierdzenie płatności',
    Informacja_o_patnoci: 'Informacja o płatności',
    Badanie_uzupenienie_dokumentw: 'Badanie, uzupełnienie dokumentów',
    Zlecono_badanie_online: 'Zlecono badanie online',
    Faktura_sprzeday: 'Faktura sprzedaży',
    E_Paragon: 'E-Paragon',
    Przypomnienie_o_patnoci: 'Przypomnienie o płatności',
    Kod_weryfikacyjny_2FA: 'Kod weryfikacyjny 2FA',
    Podsumowanie_automatycznego_fakturowania: 'Podsumowanie automatycznego fakturowania',
    Anulowanie_orzeczenia: 'Anulowanie orzeczenia'
} as const;
export type EmailPreviewDtoEmailTypeEnum = typeof EmailPreviewDtoEmailTypeEnum[keyof typeof EmailPreviewDtoEmailTypeEnum];


/**
 * Check if a given object implements the EmailPreviewDto interface.
 */
export function instanceOfEmailPreviewDto(value: object): value is EmailPreviewDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('emailType' in value) || value['emailType'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('htmlContent' in value) || value['htmlContent'] === undefined) return false;
    return true;
}

export function EmailPreviewDtoFromJSON(json: any): EmailPreviewDto {
    return EmailPreviewDtoFromJSONTyped(json, false);
}

export function EmailPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailPreviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'emailType': json['emailType'],
        'subject': json['subject'],
        'htmlContent': json['htmlContent'],
    };
}

export function EmailPreviewDtoToJSON(value?: EmailPreviewDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'emailType': value['emailType'],
        'subject': value['subject'],
        'htmlContent': value['htmlContent'],
    };
}

